module.exports = __webpack_public_path__ + "static/1930425_22809502223_1935_n-65e563838afeb3f85e8f9e7491177e78.jpg";